import React from 'react';
import PropTypes from 'prop-types';

import SamplesSpecificationsTable from './SamplesSpecificationsTable';

const CategoricalComponent = props =>
  <div className="content-item">
    <div className="flex space-between">
      <p className="font-700 mb-10">
        Summary Table
      </p>
    </div>

    <SamplesSpecificationsTable
      {...props.samplesSpecifications}
      parameterLevel={props.primaryParameterLevel}
      primaryParameter={props.primaryParameter}
    />
  </div>;

CategoricalComponent.propTypes = {
  samplesSpecifications: PropTypes.object.isRequired,
  primaryParameterLevel: PropTypes.string.isRequired,
  primaryParameter: PropTypes.string.isRequired
};

export default CategoricalComponent;
